<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Qm0meG/media/FC-9781035806546.jpg?1708094060634" alt="This image is the cover for the book Lost Dreams"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost Dreams
      </h1>
      <p class="bookDescription body article font2">
        <p>Step into a whimsical world with Kevin, a curious boy who finds himself in a fantastical realm far from home. Joined by Ben, an extraordinary talking dog, and Pete, a brave young adventurer, Kevin sets out on a quest to reach the enigmatic House of Dreams, the key to returning to their own worlds. Along the way, the trio encounter a colourful tapestry of characters and face trials that test their friendship, courage, and ingenuity. Dive into a story filled with wonder, magic, and unforgettable adventures as Kevin, Ben, and Pete journey toward the ultimate destination that promises a way back home.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        W. P. Ferguson
      </h2>
      
      <p class="authorDescription body article">It’s an amazing feat that this is Pete’s third book… It’s not been an easy journey as he’s dyslexic, and has only ever read one book himself. After having a serious accident during the first covid lockdown, he has amazed himself and everyone around him with his writing skills. He always had the imagination but could never put it into words – they say miracles do happen, so maybe this is his miracle.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bad5e72a